"use client";
import {forwardRef, useImperativeHandle} from "react";
import styles from "./form.module.css"

type MyFormProps = {
    children?: React.ReactNode;
    footer?: React.ReactNode;
    onSubmit?: React.FormEventHandler<HTMLFormElement>;
    // [key: string]: any;
}

function myForm(props: MyFormProps) {
    const {
        children,
        footer,
        onSubmit
    } = props;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log("handleSubmit", props, e);
    }

    return (
        <form action="/pwa-game-box/public" onSubmit={onSubmit}>
            {children}
            <div>{footer}</div>
        </form>
    )
}

type MyFormItemRefProps = {}
type MyFormItemProps = {
    children?: React.ReactNode;
    prefix?: React.ReactNode;
    extra?: React.ReactNode;
    errorTips?: React.ReactNode;
    [key: string]: any;
}
myForm.Item = forwardRef<MyFormItemRefProps, MyFormItemProps>(function Item(props, ref) {
    const {
        prefix,
        children,
        extra,
        errorTips = null,
    } = props;

    useImperativeHandle(
        ref,
        () => ({})
    )

    return (
        <div className={styles.item}>
            <div className={styles.item_wrapper}>
                <div>{prefix}</div>
                <div className={styles.main_input}>{children}</div>
                <div>{extra}</div>
            </div>
            <div className={styles.errorTips}>{errorTips}</div>
        </div>
    )
});

interface FormProps {
    ({children}: MyFormProps): React.ReactNode;
    Item: (props: MyFormItemProps) => React.ReactNode;
}
const Form: FormProps = myForm;

export default Form;